import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import PanelHeader from "components/panelHeader/panelHeader";
import Index from "views";
import Detalle from "views/detalle";
import Planes from "views/planes";
import Pagina_Construccion from "views/pagina_construccion";
import AcercaDe from "views/acerca_de";
import IFT1 from "views/IFT1";
import IFT2 from "views/IFT2";
import Aviso from "views/Aviso";
import Politicas from "views/Politicas";
import Contactanos from "views/contactanos";
import Easycool from "views/contacto";
import Layout from "views/Layout2";
import TagManager from 'react-gtm-module';

export const AppRouter = () => {
    const location = useLocation();

    useEffect(() => {
        // console.log(location)
        // TagManager.dataLayer({
        //     dataLayer: {
        //         event: 'pageview',
        //         page: location.pathname + location.search,
        //     },
        // });
    }, [location])
    return (
        <>
            <PanelHeader />
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route path={"/"} element={<Index />} />
                    <Route path={"/servicios/:id?"} element={<Detalle />} />
                    <Route path={"/productos/:id?"} element={<Detalle />} />
                    <Route path={"/nosotros/certificaciones"} element={<AcercaDe />} />
                    <Route path={"/nosotros/politicas"} element={<Politicas />} />
                    <Route path={"/servicios/planes_datos"} element={<Planes />} />
                    <Route path={"/pagina_construccion"} element={<Pagina_Construccion />} />
                    <Route path={"/contacto"} element={<Easycool />} />
                    <Route path={"/contactanos"} element={<Contactanos />} />
                    <Route path={"/acerca_de"} component={<AcercaDe />} />
                    <Route path={"/IFT"} element={<IFT1 />} />
                    <Route path={"/IFTD"} element={<IFT2 />} />
                    <Route path={"/aviso"} element={<Aviso />} />
                </Route>
            </Routes>
        </>
    )
}